import { useRef, useEffect, useState } from 'react'
import readingTime from 'reading-time'

function useReadingTime() {
  const ref = useRef()
  const [stats, setStats] = useState()

  useEffect(() => {
    const text = ref.current.innerText
    const stats = readingTime(text)
    setStats(stats)
  }, [])

  return [ref, stats]
}

export default useReadingTime
